import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button } from 'react-bootstrap';
import './style.css';
import NBAPlayerHealthScoresImg from './img/homepage/playerHealthScore.png';
import NBAPositionHealthScoresImg from './img/homepage/positionalHealthScore.png';
import NBATeamHealthScoresImg from './img/homepage/teamHealthScore.png';

import NBAHeadshot1 from './img/homepage/nbaheadshots/aaron.png';
import NBAHeadshot2 from './img/homepage/nbaheadshots/barkley.png';
import NBAHeadshot3 from './img/homepage/nbaheadshots/pat_mahomes.png';
import NBAHeadshot4 from './img/homepage/nbaheadshots/Hill.png';

import herone from './img/herone.png';
import herotwo from './img/herotwo.png';
import herothree from './img/herothree.png';
import smartfantasy from './img/smartfantasy.png';
import predictiveplayer from './img/predictiveplayer.png';
import oneplatform from './img/oneplatform.png';
import blue from './img/blue.png';

import barcelona from './img/barcelona.png';
import kansas from './img/kansas.png';
import saquon from './img/saquon.png';

import { Event } from '../Tracking';

function Dashboard(props) {
	const {
		schedules,
		teams,
		user,
		purchasePlan,
		freeAccess,
		dispatch,
		sources
		// carouselArticleImages,
	} = props;

	if (!schedules && !teams) return null;
	if (schedules.data && !schedules.data.schedules && teams.data && !teams.data.teamInfo && !schedules?.isLoading) {
		return (
			<React.Fragment>
				<div id='fullHeight'>
					<div id='loading' />
				</div>
			</React.Fragment>
		);
	}

	if (user.isLoading || purchasePlan.isLoading || schedules.isLoading || freeAccess?.isLoading) {
		return (
			<div id='fullHeight'>
				<div id='loading' />
			</div>
		);
	}

	const [isOpen, setIsOpen] = useState(false);

	const handleToggle = () => {
		setIsOpen(prev => !prev);
	};

	return (
		<div>
			<section id='homeMainSection' className='homeMainSection'>
				<div className='homeMainDiv'>
					<div className="heroBanner">
						<ul>
							<li>
								<img src={herone} alt='NBA Headshot' />
								<p><a href="/nba/upcominggames" className="button">NBA</a></p>
							</li>
							<li>
								<img src={herone} alt='IPL' />
								<p><a href="/cricket/upcominggames?league=IPL" className="button">IPL</a></p>
							</li>
							<li>
								<img src={herotwo} alt='nfl' />
								<p><a href="/nfl/upcominggames" className="button">NFL</a></p>
							</li>
							<li>
								<img src={herothree} alt='soccer' />
								<div className='soccer'>
									<div className={`button soccor-button ${isOpen ? 'open' : ''}`} onClick={handleToggle} >Soccer
									<div className='soccer-select-wrapper' style={{ display: isOpen ? 'block' : 'none' }}>
									<div className='soccer-select'>
										<div>
											<a href='/soccer/upcominggames?league=EPL' className='soccer-item-link'>
												EPL
											</a>
										</div>
										<div>
											<a href='soccer/upcominggames?league=ESP' className='soccer-item-link'>
														La Liga
													</a>
												</div>
											</div>
										</div>
									</div>
									
								</div>
								
							</li>
						</ul>
						<div className="heroverlay">
							<h2>The Injury Edge: Bet Smarter. Play Smarter.</h2>
							<h2>Across the NBA, NFL, Soccer & IPL</h2>
							<p>Real-time health scores, predictive analytics, and medical-grade injury analysis</p>
						</div>
					</div>
					<div className="winMore">
						<div className="container">
							<h2>Win More. Brag More.</h2>
							<p>Inside Injuries elevates your betting with science-backed injury analysis and expert insights. Experience the thrill of making informed, winning decisions.</p>
							<a
								href={user?.login ? "/signup" : "/signup"}
								className="button"
								onClick={e => {
									if (user?.login) {
										e.preventDefault();
										alert('Already logged in');
									}
								}}
							>
								Sign Up For Free
							</a>
						</div>
					</div>
					<div className="smarterfantasy">
						<div className="container">
							<ul>
								<li>
									<div className="smarticon">
										<img src={smartfantasy} alt="Smart Fantasy" />
									</div>
									<h3>Smarter Fantasy. Sharper Bets. Better Insights.</h3>
									<p>Every injury is assessed using our proprietary algorithm built by physicians and data scientists.</p>
								</li>
								<li>
									<div className="smarticon">
										<img src={predictiveplayer} alt="Predictive Player" />
									</div>
									<h3>Predictive Player Health Scores</h3>
									<p>Know who’s ready to dominate — and who’s a risk — before the game starts.</p>
								</li>
								<li>
									<div className="smarticon">
										<img src={oneplatform} alt="One Platform" />
									</div>
									<h3>One Platform. Every League.</h3>
									<p>From Premier League to NBA<br/> tipoff to Sunday NFL matchups, we’ve got you covered.</p>
								</li>
							</ul>
							<h3>See the difference with Inside Injuries</h3>
							<p>Discover how Inside Injuries has revolutionized DFS play. From last-minute lineup changes to season-long strategic adjustments, our platform is an indispensable tool for serious DFS players.</p>
						</div>
					</div>
					<div className="zigzig">
						<div className="container">
							<div className="zigzig-text-img">
								<div className="zigzig-img">
									<img src={saquon} alt="saquon" />
								</div>
								<div className="zigzig-text">
									<h3>Player Heath Scores</h3>
									<p>Your ultimate tool for individual player insights. Factor this in with the Team Health Score and you can really start pinpointing which players are set to shine.</p>
								</div>
							</div>
							<div className="zigzig-img-text">
								<div className="zigzig-img">
									<img src={kansas} alt="kansas" />
								</div>
								<div className="zigzig-text">
									<h3>Team Health Score</h3>
									<p>The Team Health Score combines injury and health analysis on key players to determine the overall health of the team.</p>
								</div>							
							</div>
							<div className="zigzig-text-img">
								<div className="zigzig-img">
									<img src={barcelona} alt="barcelona" />
								</div>
								<div className="zigzig-text">
									<h3>Position Health Score</h3>
									<p>Dig deeper into a matchup and see the health of key players and how each position group matches up with the other team.</p>
								</div>
							</div>
							{!user?.login && (
								<a href="/signup" className="button">Sign Up For Free</a>
							)}
						</div>
					</div>
					
					{/* <div className='homeDifferenceDiv mainContainer pb-0'>
						<h1 className='homeDifferenceHeader'>See the difference with Inside Injuries</h1>
						<p className='homeDifferenceText'>Discover how Inside Injuries has revolutionized DFS play. From last-minute lineup changes to season-long strategic adjustments, our platform is an indispensable tool for serious DFS players.</p>
					</div>
					<div className='homeHealthScoresDiv mainContainer'>
						<Row className='homeHealthScoresRow'>
							<Col lg={6} className='homeHealthScoresCol'>
								<div className='homeHealthScoresTextDiv'>
									<p className='homeHealthScoresHeader'>
										Player health score
										<span className='homeHealthScoresHeaderUnderline homeHealthScoresHeaderUnderlinePlayer' />
									</p>
									<p className='homeHealthScoresText'>Your ultimate tool for individual player insights. Factor this in with the Team Health Score and you can really start pinpointing which players are set to shine.</p>
								</div>
							</Col>
							<Col lg={6} className='homeHealthScoresCol'>
								<div className='homeHealthScoresImgDiv'>
									<img src={NBAPlayerHealthScoresImg} alt='Player Health Score' className='homeHealthScoreImg homePlayerHealthScoreImg' />
								</div>
							</Col>
						</Row>
						<Row className='homeHealthScoresRow'>
							<Col lg={6} className='homeHealthScoresCol'>
								<div className='homeHealthScoresTextDiv'>
									<p className='homeHealthScoresHeader'>
										Positional health score
										<span className='homeHealthScoresHeaderUnderline homeHealthScoresHeaderUnderlinePositional' />
									</p>
									<p className='homeHealthScoresText'>Dig deeper into a matchup and see the health of key players and how each position group matches up with the other team.</p>
								</div>
							</Col>
							<Col lg={6} className='homeHealthScoresCol'>
								<div className='homeHealthScoresImgDiv'>
									<img src={NBAPositionHealthScoresImg} alt='Positional Health Score' className='homeHealthScoreImg homePositionalHealthScoreImg' />
								</div>
							</Col>
						</Row>
						<Row className='homeHealthScoresRow'>
							<Col lg={6} className='homeHealthScoresCol'>
								<div className='homeHealthScoresTextDiv'>
									<p className='homeHealthScoresHeader'>
										Team health score
										<span className='homeHealthScoresHeaderUnderline homeHealthScoresHeaderUnderlineTeam' />
									</p>
									<p className='homeHealthScoresText'>The Team Health Score combines injury and health analysis on key players to determine the overall health of the team.</p>
								</div>
							</Col>
							<Col lg={6} className='homeHealthScoresCol'>
								<div className='homeHealthScoresImgDiv'>
									<img src={NBATeamHealthScoresImg} alt='Team Health Score' className='homeHealthScoreImg homeTeamHealthScoreImg' />
								</div>
							</Col>
						</Row>
					</div>
					<div className='homeWinMoreDiv'>
						<div className='mainContainer py-0'>
						<h1 className='homeWinMoreHeader'>Win More. Brag More.</h1>
						<p className='homeWinMoreText'>Inside Injuries elevates your betting with science-backed injury analysis and expert insights. Experience the thrill of making informed, winning decisions.</p>
						</div>		
					</div>
					<div className='homeScienceDiv mainContainer'>
						<h1 className='homeScienceHeader'>Science-Backed Insights.</h1>
						<p className='homeScienceText'>Embark on a new era of fantasy sports strategy with Inside Injury, where extensive medical research meets data science. Our pioneering algorithm, crafted by top orthopedic surgeons, radiologists, and data scientists, leverages over one million data points to provide unparalleled insights.</p>
						<div className='homeScienceCardDiv'>
							<Row className='homeScienceCardRow'>
								<Col lg={3} className='homeScienceCardCol'>
									<div className='homeScienceCard'>
										<div className='howScienceCardImgDiv howScienceCardImgDivFantasy' />
										<div className='homeScienceCardTextDiv'>
											<p className='homeScienceCardText'>
												<b>Improve Fantasy Scores and Maximize Sports Betting Earnings with Inside Injuries</b>
											</p>
											<a href='/articles/fantasyscore' title='Improve Fantasy Scores Article' target='_blank' rel='noreferrer' className='homeScienceCardLink'>
												READ MORE {'>'}
											</a>
										</div>
									</div>
								</Col>
								<Col lg={3} className='homeScienceCardCol'>
									<div className='homeScienceCard'>
										<div className='howScienceCardImgDiv howScienceCardImgDivPower' />
										<div className='homeScienceCardTextDiv'>
											<p className='homeScienceCardText'>
												<b>The Power of Inside Injuries' Comprehensive Sports Injury Data</b>
											</p>
											<a href='/articles/powerofinsideinjuries' title='The Power of Inside Injuries Article' target='_blank' rel='noreferrer' className='homeScienceCardLink'>
												READ MORE {'>'}
											</a>
										</div>
									</div>
								</Col>
								<Col lg={3} className='homeScienceCardCol'>
									<div className='homeScienceCard'>
										<div className='howScienceCardImgDiv howScienceCardImgDivImpact' />
										<div className='homeScienceCardTextDiv'>
											<p className='homeScienceCardText'>
												<b>Understanding the Impact of Injuries on NFL Performance, Fantasy, and Sports Betting</b>
											</p>
											<a href='/articles/impactofinjuries' title='Understanding the Impact of Injuries Article' target='_blank' rel='noreferrer' className='homeScienceCardLink'>
												READ MORE {'>'}
											</a>
										</div>
									</div>
								</Col>
								<Col lg={3} className='homeScienceCardCol'>
									<div className='homeScienceCard'>
										<div className='howScienceCardImgDiv howScienceCardImgDivDoctorsEdge' />
										<div className='homeScienceCardTextDiv'>
											<p className='homeScienceCardText'>
												<b>Unveiling the Doctor's Edge</b>
											</p>
											<a href='/articles/doctorsedge' title="Unveiling the Doctor's Edge Article" target='_blank' rel='noreferrer' className='homeScienceCardLink'>
												READ MORE {'>'}
											</a>
										</div>
									</div>
								</Col>
							</Row>
						</div>
					</div>
					<div className='homeFooterDiv mainContainer'>
						<p className='homeFooterHeader'>Experience the fusion of sports and science, offering you real-time injury updates and player health scores.</p>
						{/* {!user?.login ? (
							<Button
								className='signupButton homeCoverSignupButton'
								onClick={() => {
									dispatch({
										type: 'AUDIT',
										payload: { action: 'SIGNUP' }
									});
									Event(sources?.source, 'CLICK_SIGNUP', 'DASHBOARD_SIGNUP_BUTTON');
								}}
								href='/signup'
							>
								JOIN FOR FREE
							</Button>
						) : ( */}
							{/* <Button href='/nba/upcominggames' className='signupButton homeCoverSignupButton'>
								UPCOMING GAMES
							</Button> */}
						{/* )} */}
					{/* </div> */}
				</div>
			</section>
		</div>
	);
}

const mapStateToProps = (state) => ({
	isLoading: state.isLoading,
	isLoaded: state.isLoaded,
	freeAccess: state.freeAccess,
	schedules: state.schedules,
	teams: state.teams,
	playersInfo: state.playersInfo,
	match: state.match,
	user: state.user,
	purchasePlan: state.purchasePlan,
	sources: state.sources,
	prices: state.prices
});

export default connect(mapStateToProps)(Dashboard);
